<div
  class="error-message"
  [class]="fullPage ? 'full-page' : ''">
  <div class="container text-center">
    <div class="error-message__body">
      <img
        class="error-message__image img-fluid"
        src="assets/404.svg"
        alt="404"
        width="600" />
      <h1 [class]="textClass">The page you are looking for does not exist</h1>
      <a
        [routerLink]="backUrl"
        class="btn btn-primary">
        {{ btnText }}
      </a>
    </div>
  </div>
</div>
